<div class="container mt-2">
  <div class="row">
    <div class="col-md-12">
      <div class="row mb-4 d-flex justify-content-end">
        <div class="col-md-4">
          <h1 uni-heading color="primary" alignText="center" class="mt-1">Consulta de Usuarios {{isOperative? "Operativos" : "Corporativos"}} Fiduciaria</h1>
        </div>
        <div class="col-md-4">
          <div class="actions">
            <a
              [routerLink]="isOperative ? ['/portales/fiduciaria/create-fiduciary-user-canales/operational'] : ['/portales/fiduciaria/create-fiduciary-user-canales']"
              uni-button
              variant="info"
              icon="plus-circle"
              [iconReverse]="true"
              class="btn-slim float-md-right"
            >
              Nuevo Usuario
            </a>
            <button
              uni-button
              variant="info"
              icon="filter"
              [iconReverse]="true"
              class="btn-slim float-md-right mr-3"
              (click)="toggleFilter()"
            >
              Filtrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <filtro-tabla (searchClicked)="filterUsuarios($event)" [showForm]="showForm"></filtro-tabla>
    </div>

    <div class="col-md-12">
      <filter-table-server
        [reset]="resetPagination.asObservable()"
        (serviceConsuming)="pageChange($event)"
        [serverSidePagination]="serverSidePagination"
        [serverMode]="serverMode"
        [columns]="columns"
        [searchCols]="searchCols"
        [data]="observableUsuarios"
        [selectedData]="selectedUsers"
        [excelName]="excelName"
      >
        <ng-template #actions let-row="row" let-value="value" ngx-datatable-cell-template>
          <button tooltip="Editar" uni-icon-button variant="info" (click)="editUser(row)">
            <uni-icon name="edit-2"></uni-icon>
          </button>
          <button
            [tooltip]="row.activo ? 'Bloquear' : 'Desbloquear'"
            uni-icon-button
            variant="info"
            (click)="row.activo ? lockUser(row) : unlockUser(row)"
            class="mx-3"
          >
            <uni-icon [name]="row.activo ? 'lock' : 'unlock'"></uni-icon>
          </button>
          <button tooltip="Reiniciar Contraseña" uni-icon-button variant="info" (click)="resetUserPassword(row)">
            <uni-icon name="key"></uni-icon>
          </button>
        </ng-template>
      </filter-table-server>
    </div>
  </div>
</div>
